import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

export const Route = createFileRoute('/_app/payment/success')({
  component: PaymentSuccess,
})

function PaymentSuccess() {
  const navigate = Route.useNavigate()

  useEffect(() => {
    const ref = setTimeout(() => {
      navigate({ to: '/', replace: true })
    }, 3000)

    return () => {
      clearTimeout(ref)
    }
  }, [])

  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <h2 className="text-2xl text-emerald-500">Pagamento aprovado !</h2>
      <p className="text-xl text-muted-foreground">Você será redirecionado ao Dashboard</p>
    </div>
  )
}
